// País inicial do comprador no checkout. Fonte: IP, resolvido pela Vercel em /api/geo.
// Sem resposta (localhost, timeout, IP não identificado) o checkout fica em BR.

export const DEFAULT_BUYER_COUNTRY = "BR"

// Teto de espera pela geolocalização; a tela de carregamento segura até lá.
const GEO_TIMEOUT_MS = 1500

const isCountryCode = (value?: string | null): value is string =>
  !!value && /^[A-Z]{2}$/.test(value) && value !== "XX"

/** País forçado pela URL (`?country=US`), útil para QA e links de campanha. */
export const getBuyerCountryFromQuery = (
  search: string = window.location.search
): string | null => {
  const country = new URLSearchParams(search).get("country")?.toUpperCase()
  return isCountryCode(country) ? country : null
}

/** País pelo IP do comprador; null quando não deu para identificar. */
export const fetchBuyerCountryByIp = async (
  timeoutMs: number = GEO_TIMEOUT_MS
): Promise<string | null> => {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const response = await fetch("/api/geo", {
      signal: controller.signal,
      cache: "no-store",
    })
    if (!response.ok) return null
    const data = await response.json()
    const country = String(data?.country ?? "").toUpperCase()
    return isCountryCode(country) ? country : null
  } catch {
    // Sem a função da Vercel (dev local) o fetch devolve o index.html e o JSON falha.
    return null
  } finally {
    clearTimeout(timer)
  }
}

/** Precedência: `?country=` > IP > BR. */
export const detectBuyerCountry = async (): Promise<string> =>
  getBuyerCountryFromQuery() ??
  (await fetchBuyerCountryByIp()) ??
  DEFAULT_BUYER_COUNTRY
